"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M3 10.281c1.555-.1933 3.081-.87 4.1784-2.0337C8.5625 6.7797 9.4256 4.3237 9.566 3.8992c.4143-1.2534 1.6329-2.1335 2.9702-1.8438 1.3332.2889 2.1829 1.6129 1.9055 2.9428-.0368.181-.303 1.4677-.7442 2.9346H18.5c1.3807 0 2.5 1.1049 2.5 2.4679 0 .3086-.0574.604-.1622.8763.6986.4377 1.1622 1.208 1.1622 2.0852s-.4636 1.6476-1.1622 2.0852c.1048.2724.1622.5677.1622.8763 0 .8055-.3909 1.5209-.9956 1.9713-.0005.4817-.0204 1.4676-.7154 2.3138C18.5529 21.505 17.2816 22 15.3481 22c-2.3821 0-4.1343-.4033-6.9183-1.2465C5.8161 19.9618 4.4264 19.6026 3 19.566v-9.285z"
  })];
};

exports.default = _default;